import { render, staticRenderFns } from "./excess-info.vue?vue&type=template&id=b887586e&scoped=true&"
import script from "./excess-info.vue?vue&type=script&lang=js&"
export * from "./excess-info.vue?vue&type=script&lang=js&"
import style0 from "./excess-info.vue?vue&type=style&index=0&id=b887586e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b887586e",
  null
  
)

export default component.exports